
export const PAGE_OPT = {
    LIST: {
        pg_rowsize: 5,
        pageNo: 1,
        pageCountOfGroup: 5
    },
    PREVIEW: {
        pg_rowsize: 5,
        pageNo: 1,
    }
}

export const SEARCH_OPT = {
    LIST: {
        category: null,
        searchValue: null,
    },
    PREVIEW: {
        category: null,
        searchValue: null,
    }
}
